import React from 'react';
import PropTypes from 'prop-types';
import Link from './Link';
import styled from 'styled-components';

import breakpoints from '../styles/breakpoints';

import Section, { Title, Content } from './Section';

const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -${p => p.theme.gutterXSmall};
`;

const Item = styled(Link)`
  display: block;
  text-align: center;
  text-decoration: none;
  transition: border-color 0.5s;
  flex: 100%;
  padding: 0 ${p => p.theme.gutterXSmall};

  ${breakpoints.medium`
    flex: calc(50% - ${p => p.theme.gutterXSmall} * 2);
  `}
  ${breakpoints.large`
	flex: 0 0 20%;
	max-width: 20%;
  `}

  &:hover h4 {
    color: ${p => p.theme.colors.primary};
    border-color: ${p => p.theme.colors.primary};
  }
`;

const Image = styled.div`
  background-color: ${p => p.theme.colors.darkBg};
  background-image: ${p => (p.bgImage ? `url(${p.bgImage})` : 'null')};
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  margin-bottom: 20px;
  padding-bottom: 66.67%;
  height: 0;
  width: 100%;
`;

const ItemTitle = styled.h4`
  color: ${p => p.theme.colors.lightFont};
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 1.2;
  padding: 0 0 28px 0;
  transition: color 0.5s;
  border-bottom: 1px solid ${p => p.theme.colors.border};
`;

export default function PopularCategoriesSection({ categories }) {
  const renderCategoryList = categories.map(({ id, image, url, name }) => (
    <Item key={id} to={url}>
      <Image bgImage={image} />
      <ItemTitle>{name}</ItemTitle>
    </Item>
  ));

  return (
    <Section>
      <Title>Populære kategorier</Title>

      <Content>
        <Grid>{renderCategoryList}</Grid>
      </Content>
    </Section>
  );
}

PopularCategoriesSection.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.object)
};

PopularCategoriesSection.defaultProps = {
  categories: []
};
